<template>
    <div class="share-preview-contract" v-html="contract"></div>
</template>
<script>
import { 
    apiShareHousePreviewContract
} from "@/apis/api.js"; 

export default {
    data(){
        return {
            contract: null
        }
    },
    mounted() {
        this.previewContract()
        this.$analyticsTenant.logEvent('預覽合約', { screen_name: '預覽合約'})
    },  
    methods: {
        previewContract: function () {
            let params = {
                houseCid: this.$route.query.houseCid
            }
            apiShareHousePreviewContract(params)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.contract = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
    }
}
</script>
<style lang="scss">
.share-preview-contract{
    .contract-block{
        margin-left: auto;
        margin-right: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/shareHouse/previewContact.vue